var Theme = Theme || {};

Theme.UserComments = (function ($) {
    var $body = $('body');
    var $commentModal = $('#divCommentModal');
    var $commentModalSpinner = $('.comment-form__modal .preloader-wrap');
    var $commentFormResponse = $('.js-comment-form-response');
    var $commentFormResponseSuccess = $('.js-comment-form-response-success');
    var $commentFormResponseError = $('.js-comment-form-response-error');

    var userCommentResourceType = $('#userCommentResourceType').val();
    var userCommentResourceId = $('#userCommentResourceId').val();
    var showUserCommentWidget = $('#showUserCommentWidget').val();
    var userCommentInstance = $('#userCommentInstance').val();
    var autoPublishUserComments = $('#autoPublishUserComments').val();
    var showDisclosure = $('#userCommentShowDisclosure').val();
    var showAffiliations = $('#userCommentShowAffiliations').val();

    var $noAccessModal = $('.js-user-comment-modal-noaccess');

    return {
        init: _init
    };

    function _init() {
        commentModalOpenerClickEvent();
        submitUserComment();
        closeUserCommentModal();
        closePaywallModal();
        toggleConflictOfInterestChkBox();
        moveSubmitCommentLink();
    }

    function commentModalOpenerClickEvent() {
        $('#comment-modal-opener').on('click', function () {
            var isLoggedIn = $(this).data('loggedin');

            if (isLoggedIn === 'True') {
                openCommentModal();
            } else {
                showNoAccessModal();
            }
        });
    }

    function openCommentModal() {
        if (showUserCommentWidget !== 'True') {
            SCM.Utilities.Reveal.open($(`#${userCommentInstance}`));
        } else {
            _resetCommentForm();
            SCM.Utilities.Reveal.open($commentModal);
            SCM.Focus.trap($commentModal);
            $body.addClass('on-canvas');
        }
    }

    function showNoAccessModal() {
        $body.addClass('on-canvas');
        SCM.Utilities.Reveal.open($noAccessModal);
        SCM.Focus.trap($noAccessModal);
    }

    function submitUserComment() {
        $(document.body).on('click', '#divCommentModal .btnUserCommentSubmit', function (e) {
            e.preventDefault();
            if (_validateCommentForm()) {
                $body.addClass('wait');
                $commentModalSpinner.removeClass('hide');
                _submitCommentValues();
            }
        });
    }

    function closePaywallModal() {
        $('.js-login-modal-close').on('click', function () {
            _handleModalClose($noAccessModal);
        });
    }

    function _handleModalClose($modal) {
        SCM.Utilities.Reveal.close($modal);
        SCM.Focus.release($modal);
        $body.removeClass('on-canvas');
    }

    function closeUserCommentModal() {
        var closeElements = '#divCommentModal .btnModalCancel, #divCommentModal .btnCommentModalExit, .comment-form__close';
        $(document.body).on('click', closeElements, function (e) {
            e.preventDefault();
            SCM.Utilities.Reveal.close($commentModal);
            SCM.Focus.release($commentModal);
            $body.removeClass('on-canvas');
        });
    }
    
    function toggleConflictOfInterestChkBox() {
        $(document.body).on('change', 'input[name="NoConflicts"]', function () {
            let $disclosureBox = $('.disclosureBox');
            let $disclosureTextArea = $('textarea[id="Disclosure"]');
            if ($(this).is(':checked')) {
                $disclosureBox.removeClass('hide');
                $disclosureTextArea.prop('required', true);
            } else {
                $disclosureBox.addClass('hide');
                $disclosureTextArea.prop('required', false);
            }
        });
    }

    // Validate Form Data
    // This is written in plain JavaScript using the Constraint Validation API
    // This is NOT jQuery. Proceed with caution.
    function _validateCommentForm() {

        let isValid = true;

        const CommentForm = document.getElementById('divUserCommentForm');
        const FormFields = CommentForm.getElementsByClassName('comment-form__input');

        for (const field of FormFields) {
            let inputError = document.querySelector(`#${field.id} ~ .comment-form-error-span`);
            let inputSpan = document.querySelector(`span.comment-form__input-display-span[for=${field.id}]`);

            if (field.validity.valid) {
                inputError.classList.add('hide');
                if (inputError && inputError.hasAttribute('aria-invalid')) {
                    inputError.removeAttribute('aria-invalid');
                }
                if (inputError && inputError.hasAttribute('aria-describedby')) {
                    inputError.removeAttribute('aria-describedby');
                }
                if (inputSpan && inputSpan.hasAttribute('aria-live')) {
                    inputSpan.removeAttribute('aria-live');
                }
            } else {
                inputError.classList.remove('hide');
                inputError.setAttribute("aria-invalid", "true");
                inputError.setAttribute("aria-describedby", `${field.id}-error"`);
                inputSpan.setAttribute("aria-live", "assertive");
                isValid = false;
            }
        }

        return isValid;
    }

    function _resetCommentForm() {
        var authorInput = $commentModal.find('#Author');

        $('#divUserCommentForm').removeClass('hide');
        $commentModal.find('input[type="text"], textarea').val('');
        $commentModal.find('div.captchaAlert').addClass('hide');
        $('input[name="NoConflicts"]').prop('checked', false);
        $('input[name="termsAndConditions"]').prop('checked', false);
        $('#recaptcha_reload').trigger('click');
        authorInput.val(authorInput.data('authorValue'));
        $commentFormResponse.addClass('hide');
        $commentFormResponseSuccess.addClass('hide');
        $commentFormResponseError.addClass('hide');
    }

    function _submitCommentValues() {
        var $commentForm = $('#divUserCommentForm');

        var affiliation = showAffiliations === 'true' ? $commentForm.find('input#AffInstitution').val() : '';
        var disclosures = showDisclosure === 'true' ? $commentForm.find('textarea#Disclosure').val() : '';
        
        var currSubdomain = App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '';
        var ajaxUrl = `${currSubdomain}/Content/SubmitUserComment`;
        var ajaxData = {
            author: $commentForm.find('input#Author').val(),
            affInstitutions: affiliation,
            disclosure: disclosures,
            title: $commentForm.find('input#Title').val(),
            comment: $commentForm.find('textarea#Comment').val(),
            resourceType: userCommentResourceType,
            resourceId: userCommentResourceId,
            recaptchaChallege: $('#recaptcha_challenge_field').val(),
            recaptchaResponse: $('#recaptcha_response_field').val()
        };

        SCM.Ajax.post(ajaxUrl, ajaxData)
            .expectActionResultModel()
            .then(_handleAjaxSuccess)
            .catch(_handleAjaxError)
            .finally(_removeWaitClassFromBody);

        function _handleAjaxSuccess() {
            $commentModalSpinner.addClass('hide');
            $commentForm.addClass('hide');

            // For clients that don't moderate comments reload page immediately so new comment appears.
            // Otherwise, reveal the successful submission text
            if (autoPublishUserComments.toLowerCase() === 'true') {
                location.reload();
            } else {
                $commentFormResponse.removeClass('hide');
                $commentFormResponseSuccess.removeClass('hide');
            }
        }
            
        function _handleAjaxError(reason) {
            console.error(reason);
            $commentModalSpinner.addClass('hide');
            $('div.captchaAlert').removeClass('hide');
            $commentFormResponseError.removeClass('hide');
        }

        function _removeWaitClassFromBody() {
            $body.removeClass('wait');
        }
    }

    function moveSubmitCommentLink() {
        var $placeHolderSubmitComment = $('.submitCommentPlaceHolder');
        var $userComment = $('.widget-UserComment');
        $placeHolderSubmitComment.append($userComment);
    }

})(jQuery);